export default "__VITE_ASSET__DxM_c53I__"